import combos from './combos'
import macAltMap from "./macAltMap";
import macShiftAltMap from "./macShiftAltMap";

let mousetrap = require('mousetrap')

// HotKey 快捷键结构体, new HotKey 时会自动绑定快捷键
class HotKey {
    name = ""   // 快捷键名
    desc = ""   // 快捷键描述
    keys = [] // 快捷键绑定的按键列表. 这里的 keys 是用户可以看见的 keys, 相当于 combos 中的 text, 而不是实际绑定的 keys, 由于 shift 和 alt 实际上会导致最后的字符变化, 绑定前需要转换
    cb = function(e, combo) { console.log("Not implemented hotkey:", combo, ",", e) }   // 快捷键绑定的回调函数
    keyType = "keydown" // 案件类型, 可选值包括: "keydown"/"keyup", 默认为 "keydown"
    // isWorkHere = function() {return true}   // 当前环境是否工作


    // name/keys/cb 是必选项
    constructor(name, keys, cb, desc, keyType) {
        this.name = name
        this.keys = keys
        this.cb = cb
        desc !== "" ? this.desc = desc : this.desc = `${keys} <=> ${cb}`
        if (keyType) this.keyType = keyType
    }

    // 绑定快捷键
    bindAll() {
        let self = this

        // this.keys 是绑定的时候传递进来的快捷键, 实际上相当于 combos 中的 text
        let bindKeys = combos.texts2keys(this.getKeys())

        // console.log("HotKey bind: bindKeys:", bindKeys)
        mousetrap.bind(bindKeys, (e, combo) => {
            if (typeof(this.cb) === "function") {
                console.log("HotKey running combo callback")
                self.cb(combo)
            } else {
                console.log("Not implemented hotkey:", combo, ",", e)
            }
        })
    }

    bind(key) {
        let bindKey = combos.text2key(key)
        // console.log("HotKey bind: bindKeys:", bindKeys)
        mousetrap.bind(bindKey, (e, combo) => {
            if (typeof(this.cb) === "function") {
                console.log("HotKey running combo callback")
                self.cb(combo)
            } else {
                console.log("Not implemented hotkey:", combo, ",", e)
            }
        })
    }

    unbind(key) {
        let bindKey = combos.text2key(key)
        mousetrap.unbind(bindKey)
    }

    unbindAll() {
        let bindKeys = combos.texts2keys(this.keys)
        bindKeys.forEach((key) => {
            mousetrap.unbind(key)
        })
    }

    texts() {
        let fKeys = []
        for (let key of this.getKeys()) {
            fKeys.push(this.format(key))
        }
        return fKeys
    }

    // format 将快捷键格式化为统一的样式
    format(key) {
        let fText = ""
        for (let word of key.split("+", )) {
            let w = word.trim()
            if (w === "meta") w = "⌘"
            fText += fText.length === 0 ? (w[0].toUpperCase() + w.slice(1)) : ("+" + w[0].toUpperCase() + w.slice(1))
        }
        return fText
    }

    // 返回当前系统的快捷键 combos 列表
    getKeys() {
        return this.keys ? this.keys : []
    }

    getTexts() {
        let texts = []
        for (let k of this.getKeys()) {
            texts.push(this.format(k))
        }
        return texts
    }

    addKey(key) {
        let lowerKey = key.toLowerCase().trim()
        this.keys.push(lowerKey)
        this.bind(lowerKey)
    }

    delKey(key) {
        let newKeys = []
        let lowerKey = key.toLowerCase().trim()
        for (let k of this.keys) {
            let lowerK = k.toLowerCase().trim()
            console.log(`delKey: lowerKey: ${lowerKey}, lowerK: ${lowerK}`)
            if (lowerK === lowerKey) {
                console.log("delKey: del", key)
                this.unbind(lowerK)
                continue
            }
            newKeys.push(k)
        }
        this.keys = newKeys
    }

    updateKey(oldKey, newKey) {
        let newKeys = []
        // console.log("updateKey: keys before update:", this.keys)
        for (let k of this.keys) {
            // console.log(`updateKey: working on ${k} with ${oldKey}}`)
            let lowerK = k.toLowerCase().trim()
            let lowerOldKey = oldKey.toLowerCase().trim()
            // console.log(`updateKey: compare ${lowerK} with ${lowerOldKey}}`)
            if (lowerK === lowerOldKey) {
                let lowerNewKey = newKey.toLowerCase().trim()
                // console.log(`updateKey: ${lowerOldKey} => ${lowerNewKey}`)
                this.unbind(lowerOldKey)
                this.bind(lowerNewKey)
                newKeys.push(lowerNewKey)
                continue
            }
            newKeys.push(k)
        }
        this.keys = newKeys
        // console.log("updateKey: updated keys:", this.keys)
    }
}

// HotKeyGroup 快捷键组
class HotKeyGroup {
    name = ""   // 快捷键组名
    desc = ""   // 快捷键组描述信息
    keys = new Map()  // 快捷键, key 是 HotKey.name, value 是 HotKey
    autoBind = false // 是否在构建实例时自动绑定所有的快捷键
    customizable = true // 是否允许自定义

    // name: 字符串, 快捷键组名
    // desc: 字符串, 快捷键组描述信息
    // keys: 数组, 快捷键, key 是 HotKey.name, value 是 HotKey
    // autoBind: boolean, 是否在构建实例时自动绑定所有的快捷键
    constructor(name, desc, keys, autoBind, customizable) {
        this.name = name
        this.desc = desc
        for (let key of keys) {
            this.keys.set(key.name, key)
        }

        this.autoBind = autoBind
        if (autoBind) this.bindAll()

        this.customizable = customizable
    }

    bindAll() {
        this.keys.forEach((key) => {
            // console.log("HotKeyGroup binding key:", key)
            key.bindAll()
        })
    }

    unbindAll() {
        this.keys.forEach((key) => {
            // console.log("HotKeyGroup binding key:", key)
            key.unbindAll()
        })
    }

    addKey(hotKey) {
        this.keys.set(hotKey.name, hotKey)
        if (this.autoBind) hotKey.bindAll()
    }

    // forEach, cb(hotKey, hotKey.Name)
    forEach(cb) {
        this.keys.forEach((v, k) => {
            cb(v, k)
        })
    }

    getKeyList() {
        return this.keys.values()
    }

    getTextsByName(keyName) {
        // console.log(this.name, ", getTextsByName: keyName:", keyName)
        if (!this.keys.has(keyName)) return null
        let key = this.keys.get(keyName)
        // console.log(this.name, ", getTextsByName: key:", key)
        if (!key) {
            return null
        }

        return key.texts()
    }

    // 根据 HotKey name 获取 HotKey, 如果不存在则返回 null
    getHotKeyByName(keyName) {
        return this.keys.has(keyName) ? this.keys.get(keyName) : null
    }
}

class HotKeyDefinition {
    groups = new Map()
    desc = ""

    constructor(groups, desc) {
        for (let group of groups) {
            this.groups.set(group.name, group)
        }
        this.desc = desc
    }

    addGroup(group) {
        this.groups.set(group.name, group)
    }

    getGroup(groupName) {
        return this.groups.get(groupName)
    }

    hasGroup(groupName) {
        return this.groups.has(groupName)
    }

    getTextsByName(keyName) {
        let texts = null
        this.groups.forEach((group) => {
            let t = group.getTextsByName(keyName)
            if (t !== null) {
                texts = t
            }
        })
        return texts
    }

    // forEach, cb(group, groupName)
    forEach(cb) {
        this.groups.forEach((v, k) => {
            cb(v, k)
        })
    }

    getGroupList() {
        return this.groups.values()
    }

    // 根据 HotKey name 获取 HotKey, 如果不存在则返回 null
    getHotKeyByName(keyName) {
        let groups = this.getGroupList()
        if (!groups) return null

        let hk = null
        for (let group of groups) {
            hk = group.getHotKeyByName(keyName)
            if (hk !== null) {
                break
            }
        }
        return hk
    }

    addCombo(keyName, combo) {
        // console.log(`addCombo: keyName: ${keyName}, combo: ${combo}`)
        let hk = this.getHotKeyByName(keyName)
        if (hk === null) return null
        hk.addKey(combo)
    }
    delCombo(keyName, combo) {
        // console.log(`delCombo: keyName: ${keyName}, combo: ${combo}`)
        let hk = this.getHotKeyByName(keyName)
        if (hk === null) return null
        hk.delKey(combo)
    }
    updateCombo(keyName, oldCombo, newCombo) {
        // console.log(`updateCombo: keyName: ${keyName}, oldCombo: ${oldCombo}, newCombo: ${newCombo}`)
        let hk = this.getHotKeyByName(keyName)
        if (hk === null) {
            console.log(`updateCombo: skip cause by HotKey ${keyName} NOT found`)
        }
        // console.log(`updateCombo: updating HotKey ${keyName}`)
        hk.updateKey(oldCombo, newCombo)
    }

    // excludeGroups: ["window", "view"]
    exportCombos() {
        let combos = new Map()
        let groups = this.getGroupList()
        for (let group of groups) {
            // Export customizable groups only
            if (!group.customizable) {
                continue
            }
            console.log("exportCombos: exporting group:", group)
            let hotKeys = group.getKeyList()
            for (let hk of hotKeys) {
                combos.set(hk.name, hk.keys)
            }
        }
        return combos
    }
    //
    // unbindAll() {
    //     let groups = this.getGroupList()
    //     for (let group of groups) {
    //         group.unbindAll()
    //     }
    // }

    reset() {
        let groups = this.getGroupList()
        for (let group of groups) {
            if (group.customizable) {
                group.unbindAll()
                this.groups.delete(group.name)
            }
        }
    }
}

export default {
    HotKey,
    HotKeyGroup,
    HotKeyDefinition,
    macAltMap: macAltMap,
    macShiftAltMap: macShiftAltMap,
    texts2keys: combos.texts2keys,
}
